var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-content d-none mb-3"},[_c('span',{staticClass:"toggle-text live-stream-toggle"},[_vm._v("Enable live stream scoring")]),_c('toggle-button',{ref:"toggleBtn",staticClass:"toggle",attrs:{"value":false,"sync":true,"width":34}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }